'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	'13_player_rugby': {
		male: 'Rugby 13 Player',
		full: 'Sports > Rugby > Rugby 13'
	},
	'15_player_rugby': {
		male: 'Rugby 15 Player',
		full: 'Sports > Rugby > Rugby 15'
	},
	'7_player_rugby': {
		male: 'Rugby 7 Player',
		full: 'Sports > Rugby > Rugby 7'
	},
	actor: {
		male: 'Comedian',
		full: 'Arts & Media> Comedien'
	},
	adventurer: {
		male: 'Adventurer',
		full: 'Expertise > Adventurer'
	},
	alpine_ski: {
		male: 'Alpine Skier',
		full: 'Sports > Skiing > Alpine Skiing'
	},
	american_football: {
		male: 'American Football Player',
		full: 'Sports > American Football'
	},
	animator: {
		male: 'Presenter',
		full: 'Arts & Media > Presenter'
	},
	archery: {
		male: 'Archer',
		full: 'Sports > Archery'
	},
	architect: {
		male: 'Architect',
		full: 'Expertise > Architect'
	},
	army_officer: {
		male: 'Army Soldier',
		full: 'Expertise > Army Soldier'
	},
	art_and_media: 'Arts & Media',
	artist: {
		male: 'Artist',
		full: 'Arts & Media > Artist'
	},
	artistic_gymnastics: {
		male: 'Artistic Gymnast',
		full: 'Sports > Gymnastics > Artistic'
	},
	astronaut: {
		male: 'Astronaut',
		full: 'Expertise > Astronaut'
	},
	athletics: {
		male: 'Athlete',
		full: 'Sports > Athletics'
	},
	author: {
		male: 'Author',
		full: 'Arts & Media > Author'
	},
	automobile: {
		male: 'Race Driver',
		full: 'Sports > Motorsports (cars)'
	},
	badminton: {
		male: 'Badminton Player',
		full: 'Sports > Badminton'
	},
	ball_dance: {
		male: 'Ballroom Dancer',
		full: 'Music & Dance > Dancing > Ballroom'
	},
	band: {
		male: 'Musician / Band',
		full: 'Music & Dance > Singer > Band'
	},
	basketball: {
		male: 'Basketball Player',
		full: 'Sports > Basketball'
	},
	biathlon: {
		male: 'Biathlete',
		full: 'Sports > Skiing > Biathlon'
	},
	bmx: {
		male: 'BMX Rider',
		full: 'Sports > Cycling > BMX'
	},
	boxing: {
		male: 'Boxer',
		full: 'Sports > Boxing'
	},
	canoeying: {
		male: 'Canoer',
		full: 'Sports > Canoeying'
	},
	ceo: {
		male: 'Company Director',
		full: 'Expertise > Company Director'
	},
	chef: {
		male: 'Head Chef',
		full: 'Gastronomy > Chef'
	},
	choreographer: {
		male: 'Choreographer',
		full: 'Music & Dance > Choreographer'
	},
	classical_dance: {
		male: 'Ballet Dancer',
		full: 'Music & Dance > Dancing > Ballet'
	},
	clay_shooting: {
		male: 'Clay Target Shooting',
		full: 'Sports > Shooting > Clay Target'
	},
	climbing: {
		male: 'Climber',
		full: 'Sports > Mountain & Climbing > Climbing'
	},
	coach: {
		male: 'Coach',
		full: 'Expertise > Coach'
	},
	composer: {
		male: 'Composer',
		full: 'Music & Dance > Composer'
	},
	conductor: {
		male: 'Conductor',
		full: 'Music & Dance > Conductor'
	},
	cost_guard: {
		male: 'Coast Guard',
		full: 'Sports > First Aid > Coast Guard'
	},
	coxless_pairs: {
		male: 'Coxless Pairs',
		full: 'Sports > Rowing > Coxless Pairs'
	},
	creator: {
		male: 'Creator',
		full: 'Fashion & Trends > Creator'
	},
	cross_country_running: {
		male: 'Cross Country Running',
		full: 'Sports > Athletics > Cross Country'
	},
	cross_country_skiing: {
		male: 'Cross Country Skiing',
		full: 'Sports > Skiing > Cross Country'
	},
	cycling: {
		male: 'Cyclist',
		full: 'Sports > Cycling'
	},
	dancer: {
		male: 'Dancer',
		full: 'Music & Dance > Dancing'
	},
	director: {
		male: 'Director',
		full: 'Arts & Media > Director'
	},
	disabilities_sports: {
		male: 'Parasports Athlete',
		full: 'Sports > Parasports'
	},
	disabilities_alpine_ski: {
		male: 'Alpine Skier (Parasports)',
		full: 'Sports > Parasports > Alpine'
	},
	disabilities_athletics: {
		male: 'Athlete (Parasports)',
		full: 'Sports > Parasports > Athletics'
	},
	disabilities_basketball: {
		male: 'Basketball Player (Parasports)',
		full: 'Sports > Parasports > Basketball'
	},
	disabilities_cycling: {
		male: 'Cyclist  (Parasports)',
		full: 'Sports > Parasports > Cycling'
	},
	disabilities_kayaking: {
		male: 'Kayaker (Parasports)',
		full: 'Sports > Parasports > Kayaking'
	},
	disabilities_nordic_ski: {
		male: 'Nordic Skier (Parasports)',
		full: 'Sports > Parasports > Nordic'
	},
	disabilities_pingpong: {
		male: 'Table Tennis Player (Parasports)',
		full: 'Sports > Parasports > Table Tennis'
	},
	disabilities_swimming: {
		male: 'Swimmer (Parasports)',
		full: 'Sports > Parasports > Swimming'
	},
	disabilities_tennis: {
		male: 'Tennis Player (Parasports)',
		full: 'Sports > Parasports > Tennis'
	},
	disabilities_triathlon: {
		male: 'Triathlete (Parasports)',
		full: 'Sports > Parasports > Triathlon'
	},
	diving: {
		male: 'Diver',
		full: 'Sports > Swimming > Diving'
	},
	dj: {
		male: 'DJ',
		full: 'Music & Dance > DJ'
	},
	doctor: {
		male: 'Doctor',
		full: 'Expertise > Doctor'
	},
	economist: {
		male: 'Economist',
		full: 'Expertise > Economist'
	},
	editor: {
		male: 'Publisher',
		full: 'Expertise > Publisher'
	},
	endurance: {
		male: 'Endurance driver',
		full: 'Sports > Motorsports (cars) > Endurance'
	},
	english_boxing: {
		male: 'English Boxer (English boxing)',
		full: 'Sports > Boxing > English'
	},
	expertise: 'Expert',
	fashion_designer: {
		male: 'Fashion Designer',
		full: 'Fashion & Trends > Fashion Designer'
	},
	fencing: {
		male: 'Fencer',
		full: 'Sports > Fencing'
	},
	fighter_pilot: {
		male: 'Fighter Pilot',
		full: 'Expertise > Fighter Pilot'
	},
	fighting: {
		male: 'Wrestler',
		full: 'Sports > Wrestling'
	},
	figure_skating: {
		male: 'Figure Skater',
		full: 'Sports > Ice Sports > Figure Skating'
	},
	fim_actor: {
		male: 'Actor (Cinema)',
		full: 'Arts & Media > Comedian > Cinema'
	},
	foil: {
		male: 'Foil Fencer',
		full: 'Sports > Fencing > Foil'
	},
	food_critic: {
		male: 'Food Critic',
		full: 'Gastronomy > Food Critic'
	},
	football: {
		male: 'Football Player',
		full: 'Sports > Football'
	},
	formula_1: {
		male: 'Formula 1 Race Driver',
		full: 'Sports > Motorsports (cars) > Formula 1'
	},
	formula_3000: {
		male: 'Formula 3000 Race Driver',
		full: 'Sports > Motorsports (cars) > Formula 3000'
	},
	free_flight: {
		male: 'Free Flight',
		full: 'Sports > Free Flight'
	},
	free_wrestling: {
		male: 'Freestyle Wrestler',
		full: 'Sports > Wrestling > Freestyle'
	},
	freestyle_motobiking: {
		male: 'Freestyle Motorcycle Rider',
		full: 'Sports > Motorsports (bikes) > Moto Freestyle'
	},
	freestyle_ski: {
		male: 'Freestyle Skier',
		full: 'Sports > Skiing > Freestyle'
	},
	freewater_swimming: {
		male: 'Open Water Swimmer',
		full: 'Sport > Swimming > Open Water'
	},
	furniture_designer: {
		male: 'Furniture Designer',
		full: 'Fashion & Trends > Furniture Design'
	},
	futurist: {
		male: 'Futurist',
		full: 'Expertise > Futurism'
	},
	gardener: {
		male: 'Gardener',
		full: 'Expertise > Gardening'
	},
	gastronomy: 'Gastronomy',
	geopolitical_scientist: {
		male: 'Geopolitical Commentator',
		full: 'Expertise > Geopolitics'
	},
	golf: {
		male: 'Golfer',
		full: 'Sports > Golf'
	},
	greco_roman_wrestling: {
		male: 'Greco-Roman Wrestler',
		full: 'Sports > Wrestling > Greco-Roman'
	},
	gymnastics: {
		male: 'Gymnast',
		full: 'Sports > Gymnastics'
	},
	handball: {
		male: 'Handballer',
		full: 'Sports > Handball'
	},
	high_hurdle_race: {
		male: 'Hurdler (high hurdles)',
		full: 'Sports > Athletics > High Hurdles'
	},
	hiphop_dance: {
		male: 'Hip-Hop Dancer',
		full: 'Music & Dance > Dancing > Hip-hop'
	},
	hockey: {
		male: 'Hockey Player',
		full: 'Sports > Hockey'
	},
	horse_riding: {
		male: 'Horse Rider',
		full: 'Sports > Horse Riding'
	},
	humorist: {
		male: 'Humorist',
		full: 'Arts & Media > Humorist'
	},
	ice_dancing: {
		male: 'Ice Dancer',
		full: 'Sports > Ice Sports > Ice Dancing'
	},
	ice_sports: {
		male: 'Ice Sportsman',
		full: 'Sports > Ice Sports'
	},
	illustrator: {
		male: 'Cartoonist',
		full: 'Arts & Media > Cartoonist'
	},
	imitator: {
		male: 'Impersonator',
		full: 'Arts & Media > Humorist > Impersonator'
	},
	influencer: {
		male: 'Influencer',
		full: 'Influencer'

	},
	influencer_global: {
		male: 'Global Influencer',
		full: 'Influencer > General'
	},
	interior_designer: {
		male: 'Interior Designer',
		full: 'Fashion & Trends > Interior Design'
	},
	interpretor: {
		male: 'Interpreter',
		full: 'Music & Dance > Interpreter'
	},
	jet_ski: {
		male: 'Jet Ski Rider',
		full: 'Sports > Jet Ski'
	},
	jockey: {
		male: 'Jockey',
		full: 'Sports > Horse Riding > Jockey'
	},
	journalist: {
		male: 'Journalist',
		full: 'Arts & Media > Journalist'
	},
	judo: {
		male: 'Judoka',
		full: 'Sports > Judo'
	},
	kayaking: {
		male: 'Kayaker',
		full: 'Sports > Kayaking'
	},
	lawyer: {
		male: 'Lawyer',
		full: 'Expertise > Lawyer'
	},
	licence: {
		male: 'Licence/Brand',
		full: 'Licence/Brand'
	},
	line_racing: {
		male: 'Driver',
		full: 'Sports > Kayaking > Driver'
	},
	long_jump: {
		male: 'Athlete (Long Jump)',
		full: 'Sports > Athletics > Long Jump'
	},
	longboard: {
		male: 'Longboarder',
		full: 'Sports > Surf > Longboard'
	},
	low_hurdle_race: {
		male: 'Athlete (low hurdles)',
		full: 'Sport > Athletics > Low Hurdles'
	},
	magician: {
		male: 'Magician',
		full: 'Arts & Media > Magician'
	},
	match_racing: {
		male: 'Sailor (Match Racing)',
		full: 'Sports > Sailing > Match racing'
	},
	medium_distance_running: {
		male: 'Middle-Distance Runner',
		full: 'Sports > Athletics > Middle-Distance'
	},
	model: {
		male: 'Model',
		full: 'Fashion & Trends > Modelling'
	},
	modern_dance: {
		male: 'Modern Dancer',
		full: 'Music & Dance > Dancing > Modern'
	},
	modern_pentathlon: {
		male: 'Athlete (Modern Pentathlon)',
		full: 'Sports > Modern Pentathlon'
	},
	moto_cross: {
		male: 'Motocross Rider',
		full: 'Sports > Motorsports (bikes) > Motocross'
	},
	motocycling: {
		male: 'Motorcyclist',
		full: 'Sports > Motorsports (bikes)'
	},
	mountain_biking: {
		male: 'Mountain Biker',
		full: 'Sports > Cycling > Mountain Biking'
	},
	mountains_and_climbing: {
		male: 'Montain-Climber',
		full: 'Sports > Montain-Climbing'
	},
	multisport_raid: {
		male: 'MultiSports Race',
		full: 'Sports > Mountain & Climbing > MultiSports Race'
	},
	music_and_dancing: 'Music & Dance',
	musician: {
		male: 'Musician',
		full: 'Music & Dance > Musician'
	},
	nordic_combined: {
		male: 'Athlete (Nordic Combined)',
		full: 'Sports > Skiing  > Nordic Combined'
	},
	nordic_ski: {
		male: 'Nordic Skier',
		full: 'Sports > Skiing > Nordic Skiing'
	},
	ocean_racing: {
		male: 'Sailor (Ocean Racing)',
		full: 'Sports > Sailing > Ocean Racing'
	},
	oenologist: {
		male: 'Oenologist',
		full: 'Gastronomy > Oenology'
	},
	orienteering_race: {
		male: 'Orienteerer',
		full: 'Sports > Orienteering'
	},
	other_athletics: {
		male: 'Others Athletes',
		full: 'Sports > Athletics > Other'
	},
	painter: {
		male: 'Painter',
		full: 'Arts & Media > Painter'
	},
	philosopher: {
		male: 'Philosopher',
		full: 'Expertise > Philosophy'
	},
	photographer: {
		male: 'Photographer',
		full: 'Arts & Media > Photography'
	},
	pingpong: {
		male: 'Table Tennis Player',
		full: 'Sports > Table Tennis'
	},
	pistol_shooting: {
		male: 'Pistol Shooter',
		full: 'Sports > Shooting > Pistol'
	},
	pole_vaulting: {
		male: 'Athlete (Pole Vault)',
		full: 'Sports > Athletics > Pole Vaulting'
	},
	political_scientist: {
		male: 'Political Scientist',
		full: 'Expertise > Political Sciences'
	},
	unicorn: 'Politic',
	politics: {
		male: 'Politician',
		full: 'Politician'
	},
	other: 'Other',
	polo: {
		male: 'Polo Player',
		full: 'Sports > Horse Riding > Polo'
	},
	pool_swimming: {
		male: 'Swimmer (Pool)',
		full: 'Sports > Swimming > Pool'
	},
	professor: {
		male: 'Professor',
		full: 'Expertise > Professor'
	},
	race_walking: {
		male: 'Athlete (Race Walking)',
		full: 'Sports > Athletics> Race walking'
	},
	radio: {
		male: 'Radio Host',
		full: 'Arts & Media > Presenter > Radio'
	},
	rally: {
		male: 'Rally Driver',
		full: 'Sports > Motorsports (cars) > Rallye'
	},
	rescue_and_first_aid: {
		male: 'First Aider',
		full: 'Sports > First Aid'
	},
	road_cycling: {
		male: 'Road Cycling',
		full: 'Sports > Cycling > Road'
	},
	rowing: {
		male: 'Rower',
		full: 'Sports > Rowing'
	},
	rugby: {
		male: 'Rugby Player',
		full: 'Sports > Rugby'
	},
	running: {
		male: 'Orienteerer (Running)',
		full: 'Sports > Orienteering > Running'
	},
	rythmic_gymnastics: {
		male: 'Rhythmic Gymnastics',
		full: 'Sports > Gymnastics > Rythmic'
	},
	saber: {
		male: 'Fencer (Sabre)',
		full: 'Sports > Fencing > Sabre'
	},
	sailing: {
		male: 'Sailor',
		full: 'Sports > Sailing'
	},
	scientist: {
		male: 'Scientist',
		full: 'Expertise > Scientist'
	},
	shooting: {
		male: 'Shooter',
		full: 'Sports > Shooting'
	},
	show_jumping: {
		male: 'Horse rider (Show Jumping)',
		full: 'Sports > Horse Riding > Show Jumping'
	},
	singer: {
		male: 'Singer',
		full: 'Music & Dance > Singer'
	},
	ski_acrobatics: {
		male: 'Freestyle Skier',
		full: 'Sports > Skiing > Freestyle Skiing'
	},
	ski_mountaineering: {
		male: 'Ski Mountaineer',
		full: 'Sports > Mountain & Climbing > Ski Mountaineering'
	},
	skiff: {
		male: 'Sailor (Skiff)',
		full: 'Sports > Rowing > Skiff'
	},
	skiing: {
		male: 'Skier',
		full: 'Sports > Skiing'
	},
	slalom: {
		male: 'Skier (Slalom)',
		full: 'Sports > Kayaking > Slalom'
	},
	snorkelling: {
		male: 'Free Diver',
		full: 'Sports > Undersea Studies and Sports > Free Diver'
	},
	snowboard: {
		male: 'Snowboarder',
		full: 'Sports > Skiing > Snowboard'
	},
	sociologist: {
		male: 'Sociologist',
		full: 'Expertise > Sociology'
	},
	solo: {
		male: 'Solo',
		full: 'Music & Dance > Singing > Solo'
	},
	speaker: {
		male: 'Speaker',
		full: 'Expertise > Speaker'
	},
	speed_skating: {
		male: 'Short Tracker Speed Skating',
		full: 'Sports > Ice Sports > Speed / Short-Track'
	},
	sports: {
		male: 'Sportsman',
		full: 'Sports'
	},
	sprint_race: {
		male: 'Sprinter',
		full: 'Sports > Athl\xE9tisme > Sprint'
	},
	squash: {
		male: 'Squash Player',
		full: 'Sports > Squash'
	},
	surf_boat: {
		male: 'Surf Boat Life Saver',
		full: 'Sports > First Aid > SurfBoat'
	},
	surfing: {
		male: 'Surfer',
		full: 'Sports > Surf'
	},
	swimming: {
		male: 'Swimmer',
		full: 'Sports > Swimming'
	},
	sword: {
		male: 'Swordsman',
		full: 'Sports > Fencing > Sword'
	},
	synchromized_swimming: {
		male: 'Swimmer (Synchronized Swimming)',
		full: 'Sports > Swimming > Synchronized'
	},
	taekwondo: {
		male: 'Taekwondoka',
		full: 'Sports > Taekwondo'
	},
	target_shooting: {
		male: 'Target Shooter',
		full: 'Sports > Archery > Target Shooting'
	},
	tennis: {
		male: 'Tennis Player',
		full: 'Sports > Tennis'
	},
	thai_boxing: {
		male: 'Boxer (Thai Boxing)',
		full: 'Sports > Boxing > Thai'
	},
	theatre_actor: {
		male: 'Comedian (Theater)',
		full: 'Arts & Media > Comedian > Theater'
	},
	track_cycling: {
		male: 'Track Cyclist',
		full: 'Sports > Cycling > Track'
	},
	track_race: {
		male: 'Road Race',
		full: 'Sports > Athletics > Road Racing'
	},
	trail: {
		male: 'Trail',
		full: 'Sports > Mountain & Climbing > Trail'
	},
	trends_and_fashion: 'Fashion',
	triathlon: {
		male: 'Athlete (Triathlon)',
		full: 'Sports > Triathlon'
	},
	triple_jump: {
		male: 'Athlete (Triple Jump)',
		full: 'Sports > Athletics > Triple jump'
	},
	tv: {
		male: 'TV Presenter',
		full: 'Arts & Media > Presenter > Television'
	},
	underwater_sports_and_studies: {
		male: 'Undersea Studies and Sports',
		full: 'Sports > Undersea Studies and Sports'
	},
	volleyball: {
		male: 'Volleyball Player',
		full: 'Sports > Volley-ball'
	},
	water_polo: {
		male: 'Water Polo Player',
		full: 'Sports > Swimming > Water polo'
	},
	water_ski: {
		male: 'Water Skier',
		full: 'Sports > Water Skiing'
	},
	weight_lifting: {
		male: 'Weightlifter',
		full: 'Sports > Weightlifting'
	},
	windsurfing: {
		male: 'Windsurfer',
		full: 'Sports > Sailing > Windsurfing'
	},
	writer: {
		male: 'Writer',
		full: 'Arts & Media > Author > Writer'
	},
	youtuber: {
		male: 'Videomaker',
		full: 'Influencer > Videomaker'
	},
	blogger: {
		male: 'Blogger',
		full: 'Influencer > Blogger'
	},
	'kickboxer': {
		male: 'Kickboxer',
		full: 'Sports > Boxing > Kickboxing'
	},
	'fitness_athlete': {
		male: 'Athlete (Fitness)',
		full: 'Sports > Fitness > Athlete'
	},
	'fitness_coach': {
		male: 'Coach (Fitness)',
		full: 'Sports > Fitness > Coach'
	},
	fitness: {
		male: 'Fitness',
		full: 'Sports > Fitness'
	},
	matador: {
		male: 'Matador',
		female: 'Matadora',
		full: 'Sports > Bullfight'
	},
	skate: {
		male: 'Rider',
		full: 'Sports > Urban Glide'
	},
	urban_glide: {
		male: 'Rider',
		full: 'Sports > Urban Glide'
	},
	skateboard: {
		male: 'Skateborder',
		full: 'Sports > Urban Glide > Skateboard'
	},
	scooter: {
		male: 'Scooter Rider',
		full: 'Sports > Urban Glide > Scooter Riding'
	},

	roller_skating: {
		male: 'Rollerskater',
		full: 'Sports > Urban Glide > Rollerskating'
	},

	kitesurf: {
		male: 'Kiteboarder',
		full: 'Sport > Voile > Kiteboarding'
	},
	tatooist: {
		male: 'Tatooist',
		full: 'Arts & Media > Cartoonist > Tatooing'
	},

	comics_illustrator: {
		male: 'Cartoonist',
		full: 'Arts & Media > Illustrator > Cartoonist'
	},

	street_artist: {
		male: 'Street Artist',
		full: 'Arts & Media > Cartoonist > Street Art'
	},

	e_sport: {
		male: 'Gamer',
		full: 'Sports > E-Sport'
	},

	gamer: {
		male: 'Gamer',
		full: 'Sports > Gaming'
	},

	hairdresser: {
		male: 'Hairdresser',
		full: 'Expertise > Hairdressing'
	},

	makeup_artist: {
		male: 'Make-up Artist',
		full: 'Expertise > Make-up Artist'
	},

	art_director: {
		male: 'Art Director',
		full: 'Fashion & Trends > Art Direction'
	},

	producer: {
		male: 'Producer',
		full: 'Music & Dance > Production'
	},

	cricket: {
		male: 'Cricket Player',
		full: 'Sports > Cricket'
	},

	baseball: {
		male: 'Baseball Player',
		full: 'Sports > Baseball'
	},

	fiction_character: {
		male: 'Fiction Character',
		full: 'Other > Fiction Character'
	},
	event_or_wedding_planner: {
		male: 'Event / Wedding Planner',
		full: 'Arts & Media > Event / Wedding Planner'
	},
	reality_tv: {
		male: 'Reality TV',
		full: 'Arts & Media > Reality TV'
	},
	marketing_and_communication: {
		male: 'Marketing & Communication',
		full: 'Expertise > Marketing & Communication'
	},
	tech_and_ai: {
		male: 'Tech & AI',
		full: 'Expertise > Tech & AI'
	},
	management: {
		male: 'Management',
		full: 'Expertise > Management'
	}
};